/**
 * 地图Layer统一由后端返回
 * https://test3.hougarden.com/api/v5.1.6/map-layers
 * 
 * @Author: Focci
 * @Date: 2024-11-18 13:44:49
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-18 13:44:49
 */

import { useMapState } from '@comp/mapbox'
import { useMemo } from 'react'
import { checkLayerDisplay, RemoteLayerMapbox, RemoteLayerRaster } from './lib'

function RemoteLayer(props) {
  const { extra } = useMapState()
  const { type, locations, ...option } = props
  
  if(!checkLayerDisplay(extra, locations)) {
    return null
  }
  
  if(type === 'mapbox') {
    return <RemoteLayerMapbox option={option} />
  }

  if(type === 'raster') {
    return <RemoteLayerRaster option={option} />
  }
}

export function RemoteLayers() {
  const { layers: { cfg, display }, satellite } = useMapState()

  const layers = useMemo(() => {
    const tmp = ['initialLayers', ...display]
    satellite && tmp.push('satellite')

    return tmp
  }, [display, satellite])

  return layers.map((key) => {
    const target = cfg?.[key] || []
    return target.map((option) => (
      <RemoteLayer
        key={option.name}
        {...option}
        layerKey={key}
      />
    ))
  })
}
